var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-modal',{ref:"bookingRecapModal",attrs:{"size":"lg","title":_vm.$t('hospitality.booking.recap.title', {bookingID: _vm.booking != null ? _vm.booking._id : ''}),"hide-footer":"","lazy":""}},[(_vm.booking != null)?_c('Recap',{attrs:{"booking":_vm.booking},on:{"booking-updated":_vm.onItemUpdated}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }